import { validatePostcode } from '../utils';

export const initialState = {
  addressBookAddress: '',
  searchPostcode: '',
  postcodeValid: false,
  locationSearch: false,
  searchPostcodeError: false,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_ADDRESS_BOOK_ADDRESS':
      return { ...state, addressBookAddress: action.payload };
    case 'HANDLE_SEARCH_POSTCODE_CHANGE': {
      const isPostcodeValid = validatePostcode(action.payload).isValid;

      return {
        ...state,
        searchPostcode: action.payload,
        searchPostcodeError: false,
        postcodeValid: isPostcodeValid,
        locationSearch: !isPostcodeValid,
      };
    }
    default:
      return state;
  }
};
